// Aviso y aplicación de versión nueva sin recarga forzada del usuario
// (aprendizajes 56 y 63). El build publica /version.json; la app compara con
// la versión con que fue construida y, si cambió, recarga en el próximo cambio
// de ruta (momento seguro) o cuando el usuario toca "Actualizar".
import { ref, type Ref } from 'vue';

export interface VersionChecker {
  updateReady: Ref<boolean>;
  check: () => Promise<boolean>;
  start: () => void;
  stop: () => void;
}

export function createVersionChecker(opts: {
  current: string;
  fetchVersion: () => Promise<string | null>;
  intervalMs?: number;
}): VersionChecker {
  const updateReady = ref(false);
  let timer: ReturnType<typeof setInterval> | null = null;

  async function check(): Promise<boolean> {
    if (updateReady.value) return true;
    let remote: string | null = null;
    try {
      remote = await opts.fetchVersion();
    } catch {
      remote = null;
    }
    if (remote && remote !== opts.current) updateReady.value = true;
    return updateReady.value;
  }

  function start(): void {
    if (timer) return;
    timer = setInterval(() => void check(), opts.intervalMs ?? 5 * 60_000);
  }

  function stop(): void {
    if (timer) clearInterval(timer);
    timer = null;
  }

  return { updateReady, check, start, stop };
}

/** Lee /version.json sin caché. */
export async function fetchPublishedVersion(): Promise<string | null> {
  const resp = await fetch('/version.json', { cache: 'no-store' });
  if (!resp.ok) return null;
  const data = (await resp.json()) as { version?: string };
  return data.version ?? null;
}
